module.exports = __webpack_public_path__ + "static/media/DOT.fe70701c.svg";